
import type { Commit, Dispatch } from 'vuex'
import { getBillCountApi } from '@/apis/fund'

export default {
  namespaced: true,
  state: {
    num: 0
  },
  getters: {
    getBillNum (state: { num: number }): number {
      return state.num
    }
  },
  mutations: {
    SET_BILL_NUM: (
      state: { num: number },
      num: number
    ): void => {
      state.num = num
    }
  },
  actions: {
    getBillNum (store: any) {
      const { commit, dispatch, state, rootState } = store
      if (!rootState.route.curShop) return
      getBillCountApi({}).then((res: any) => {
        if (res.success) {
          commit('SET_BILL_NUM', res.data)
        }
      })
    }
  }
}
